import r from '../Utils/fetch'

const w: any = window
const endPoint = `${w.API_BILLING_URL}`

// setBillingAccountBrevoCompanyID rattache manuellement un BA Quanti à une
// Company Brevo existante (ou efface le lien si brevoCompanyId est vide).
// Aucun appel à l'API Brevo n'est fait côté serveur : on suppose que l'admin
// a vérifié l'existence côté UI Brevo.
export const setBillingAccountBrevoCompanyID = (
	billingAccountId: string,
	brevoCompanyId: string
): Promise<{ brevoCompanyId: string }> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/brevo-company-id`,
		method: 'PUT',
		data: { brevoCompanyId },
	})
